import { AuthContext, AuthProvider, IAuthContext, TAuthConfig } from 'react-oauth2-code-pkce'
import React, { useContext } from 'react'


  
const LoginButton = () => {
  const { tokenData, token, logIn, logOut, idToken, error } = useContext(AuthContext)
  
  return <button onClick={() => logIn()}>Log In</button>;
};

export default LoginButton;